import React, { FC, ComponentProps } from 'react'
import { useIntl, FormattedMessage as OriginalFormattedMessage } from 'react-intl'
import marked from 'marked'

import FormattedMessage from 'components/FormattedMessage'

type Props = ComponentProps<typeof FormattedMessage>

const FormattedMarkdownMessage: FC<Props> = props => {
  const intl = useIntl()
  const message = marked((intl.messages[props.id] || '') as string)

  return (
    <OriginalFormattedMessage
      {...props}
      id="_dummy"
      defaultMessage="<text></text>"
      values={{
        text: (_: any) => (
          <div dangerouslySetInnerHTML={{ __html: message }} />
        ),
      }}
    />
  )
}

export default FormattedMarkdownMessage
try {
    // @ts-ignore
    FormattedMarkdownMessage.displayName = "FormattedMarkdownMessage";
    // @ts-ignore
    FormattedMarkdownMessage.__docgenInfo = { "description": "", "displayName": "FormattedMarkdownMessage", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormattedMarkdownMessage/FormattedMarkdownMessage.tsx#FormattedMarkdownMessage"] = { docgenInfo: FormattedMarkdownMessage.__docgenInfo, name: "FormattedMarkdownMessage", path: "src/components/FormattedMarkdownMessage/FormattedMarkdownMessage.tsx#FormattedMarkdownMessage" };
}
catch (__react_docgen_typescript_loader_error) { }